/**
 * @fileoverview Sales Dashboard API service.
 * @description Calls GET /sales/dashboard (Confluence 3.5.11.40): the landing page in one read-only
 * call, with no query parameter (any is a 400). The backend decides the scope from the token and
 * leaves out every section the caller may not see, so nothing here knows who the caller is.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { httpClient } from '@/shared/api/http-client'

import type { SalesDashboard } from '@/features/sales/types/sales-dashboard.types'

/**
 * @description Fetches the Sales Dashboard.
 * @returns {Promise<SalesDashboard>} The greeting name, the scope and the sections the caller may
 * see.
 */
export async function getSalesDashboard(): Promise<SalesDashboard> {
  const { data } = await httpClient.get<SalesDashboard>('/sales/dashboard')
  return data
}
